import { Box, Grid, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const StyledBox = styled(Box)`
  width: 100%;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const StyledGridContainer = styled(Grid)`
  padding: 10px;
`;

export const StyledTableCell = styled(TableCell)`
  border: 0;
  padding-right: 0;
`;

export const StyledTotalTableCell = styled(TableCell)`
  border: 0;
  padding-right: 35px;
`;